import MainLayout from 'components/layout/MainLayout';
import { useUserStore } from 'hooks/stores/useUserStore';
import { NextSeo } from 'next-seo';
import Link from 'next/link';
import { ASSET_PREFIX } from 'utils/constants';

const ContactUs = () => {
  const { currentUser, subscriptions } = useUserStore();

  const faqLink =
    currentUser?.id &&
    subscriptions.find(
      (s) =>
        s.subscription.status === 'ACTIVE' ||
        s.subscription.status === 'SNOOZED' ||
        s.subscription.status === 'FAILING',
    )
      ? 'https://daymade.zendesk.com/hc/en-gb'
      : '/faq';

  return (
    <MainLayout>
      <NextSeo
        title="Contact Us | DAYMADE"
        openGraph={{
          title: 'Contact Use | DAYMADE',
        }}
      />
      <div className="mt-2 lg:mt-4 relative w-full h-[100px] lg:h-[129px]">
        <img
          src={`${ASSET_PREFIX}/images/contact-us/title-background.png`}
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover"
        />

        <h1
          className="tracking-normal normal-case absolute inset-0 flex items-center justify-center"
          style={{ textShadow: '2px 2px 0 white' }}
        >
          <span className="text-[25px] lg:text-[45px] font-black text-[#4a4a4a]">
            Contact us
          </span>
        </h1>
      </div>
      <div className="flex flex-col gap-2 lg:gap-4 max-w-[1230px] py-10 lg:py-16 px-5">
        <h2
          style={{
            borderLeft: '10px solid #90F6DF',
          }}
          className="p-2 w-full text-left tracking-normal text-[20px] lg:text-[33px] font-black text-[#4a4a4a] normal-case"
        >
          How do I contact DAYMADE?
        </h2>
        <div className="flex flex-col gap-2 lg:gap-4">
          <p className="w-full text-[13px] lg:text-[15px] !text-left">
            Want to get in touch? We’d love to hear from you!
          </p>
          <p className="w-full text-[13px] lg:text-[15px]">
            If you have a question about DAYMADE, you might want to{' '}
            <Link href={faqLink} className="underline" target="_blank">
              
                check our FAQ’s
              
            </Link>{' '}
            to find the answer to your query. Or if you still can’t find the
            answer, you can contact us via our{' '}
            <a
              className="underline"
              href={
                'https://daymade.zendesk.com/hc/en-gb/requests/new?ticket_form_id=0657'
              }
              target="_blank"
            >
              contact form
            </a>{' '}
            or by sending us a DM on{' '}
            <a
              className="underline"
              href={'https://www.instagram.com/daymadeuk?igsh=ODd1OTM1NDhxeTJ2'}
              target="_blank"
            >
              {' '}
              Instagram.{' '}
            </a>
          </p>
          <p className="w-full text-[13px] lg:text-[15px]">
            For complaints, please see our{' '}
            <Link href={'/contact-us/complaints'} className="underline">
              policy here.
            </Link>
          </p>
        </div>
      </div>
    </MainLayout>
  );
};

export default ContactUs;
